<template>
  <v-form>
    <!-- <v-container>
      <template v-for="(room, iroom) in GetBookingInfo()">
        <v-row no-gutters class="d-flex justify-space-between" :key="iroom">
          <v-col cols="6">{{ room.name }}</v-col>
          <v-col cols="6" class="d-flex justify-end">
              <v-btn
              icon
              color="red"
              @click="removeRoom(room)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row :key="'guest' + iroom">
          <v-col cols="5">
            <v-text-field label="Guest Name" dense solo></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-select label="Adults" dense solo></v-select>
          </v-col>
          <v-col cols="3">
            <v-select label="Children" dense solo></v-select>
          </v-col>
        </v-row>
        <v-divider :key="'divi' + iroom"></v-divider>
      </template>
    </v-container> -->
    <v-btn depressed color="primary" class="ml-2" @click="onAddMoreRoom">
     ADD MORE ROOM
    </v-btn>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  methods: {
    onAddMoreRoom: function () {
        this.$store.dispatch('setActiveScreen', 'room');
    },
    removeRoom: function(room){
        this.$store.dispatch('removeRoom', room);
    }
  },
  computed: {
    ...mapGetters(["GetBookingInfo"]),
  },
  watch: {
    '$store.state.bookingInfo': function(){
      if(this.GetBookingInfo().length === 0){
        this.$store.dispatch('setActiveScreen', 'room');
      }
    }
  }
};
</script>